import { configureStore, isRejectedWithValue, ThunkMiddleware } from '@reduxjs/toolkit'
import rootReducer from '../reducers/root'
import { getLogger } from '../../services/logger/logger'
import initialState, { InitState } from '../reducers/root/initialState'

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: unknown
  }
}

const errorHandlerMiddleware: ThunkMiddleware = () => (next) => (action: unknown) => {
  if (isRejectedWithValue(action)) {
    const errorMessage =
      'data' in action.error ? (action.error.data as { message: string }).message : action.error.message
    getLogger('Redux').error('Exception while processing redux', errorMessage)
  }

  return next(action)
}

export const createStore = (state: InitState) =>
  configureStore({
    preloadedState: state,
    reducer: (state, action) => rootReducer(state, action),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
      }).concat(errorHandlerMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
  })

export default createStore(initialState)
